import { createContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getChatList } from "../redux/chat/chatAction";
import { deleteMessage, markAsRead, markDelivered, reactToChat, sendMessage, updateTypingStatus } from "../redux/chat/chatReducer";
import { updateStoryView } from "../redux/story/storyReducer";
import { sendNotification, showNotification, useTabVisibility } from "../hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { useSocketInit } from "../hooks/useSocketInit";



export const SocketContext = createContext(null)

export default function SocketProvider({ children }) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { userData } = useSelector(state => state.user)
    const pathname = useLocation().pathname
    const pathnameRef = useRef(null)
    const isTabActive = useTabVisibility()
    const tabVisibilityRef = useRef(null)

    useEffect(() => {
        tabVisibilityRef.current = isTabActive
        // pathnameRef.current = pathname
    }, [isTabActive])

    useEffect(() => {
        pathnameRef.current = pathname
    }, [pathname])

    useEffect(() => {
        if (userData && userData.userId) {
            dispatch(getChatList())
        }
    }, [userData, dispatch]);

    const onNewMessage = async (msg, socket) => {
        try {
            const { message, room, sender, unreadCount } = msg;
            const { userId } = sender;
            const isSentByMe = userId === userData.userId

            const name = `${sender.firstName} ${sender.lastName}`
            const avatar = sender.profilePhoto[0].photoPublicUrl ?? ''

            const handleClick = () => navigate('/chat', { state: { user: sender } })

            if (!isSentByMe) {
                if (tabVisibilityRef.current) {
                    if (pathnameRef.current !== '/chat') {
                        showNotification(avatar, name, message.content, handleClick)
                    }
                } else {
                    sendNotification(name, message.content, avatar)
                }
            }

            const listData = {
                user: sender,
                room,
                lastMessage: message,
                unreadCount
            };

            const roomId = isSentByMe ? `${message.receiverId}_${userId}` : `${userId}_${userData.userId}`
            dispatch(sendMessage({ roomId, message, listData, isSentByMe }));

            if (!isSentByMe) {
                try {
                    const deliverData = {
                        messageId: message.messageId,
                        conversationId: room,
                        receiverId: userId,
                        senderId: userData.userId
                    }
                    // console.log('delivered info ; ', deliverData)
                    socket?.emit('markDelivered', deliverData, (response) => {
                    })
                } catch (error) {
                    console.log('unable to emit delivered; ', error.message)
                }
            }
        } catch (error) {
            console.log('Unable to handle new message', error.message);
        }
    }

    const onDelivered = async (response) => {
        try {
            const { messageId, senderId } = response
            const roomId = `${senderId}_${userData.userId}`
            console.log('delivered status recieved')

            // console.log('deliver res ; ', response)

            dispatch(markDelivered({ messageId, roomId }))

        }
        catch (error) {
            console.log('unable to deliver message', error.message)
        }
    }

    const onRead = async (response) => {
        try {
            const { messageId, senderId, receiverId } = response
            const roomId = senderId === userData.userId ? `${receiverId}_${userData.userId}` : `${senderId}_${userData.userId}`

            // console.log('red res ; ', response)

            dispatch(markAsRead({ messageId, roomId }))

        }
        catch (error) {
            console.log('unable to read message', error.message)
        }
    }

    const onReaction = async (reaction) => {
        try {

            const { messageId, reaction: emoji, senderId, receiverId } = reaction

            const reactionObject = {
                reaction: emoji,
                userId: senderId
            }

            const roomId = senderId === userData.userId ? `${receiverId}_${senderId}` : `${senderId}_${receiverId}`

            dispatch(reactToChat({ roomId: roomId, messageId, reaction: reactionObject }))
        }
        catch (error) {
            console.log('unable to react to message; ', error.message)
        }
    }

    const onTyping = async (response) => {
        try {
            const { senderId, typing } = response
            const roomId = `${senderId}_${userData.userId}`

            // console.log('type gotten ; ', response)
            if (typing) {
                dispatch(updateTypingStatus({ status: 'typing...', userId: senderId, roomId }))
            } else {
                dispatch(updateTypingStatus({ status: '', userId: senderId, roomId }))
            }
        }
        catch (error) {
            console.log('error update typing status; ', error.message)
        }
    }

    const onDelete = async (response) => {
        try {
            console.log('delted response ; ', response)
            const { senderId, messageId } = response
            const roomId = `${senderId}_${userData.userId}`
            dispatch(deleteMessage({ roomId, messageId }))
        }
        catch (error) {
            console.log('error listenning to delete message: ', error.message)
        }
    }

    const onStoryView = (response) => {
        const { postId, newViewCount } = response ?? {}

        const data = { myId: userData.userId, postId, newViewCount }
        dispatch(updateStoryView(data))
    }


    const { socket, isConnected, queueAck } = useSocketInit({
        onNewMessage,
        onDelivered,
        onRead,
        onReaction,
        onTyping,
        onDelete,
        onStoryView
    })

    return (
        <SocketContext.Provider
            value={{
                socket,
                isConnected,
                queueAck,
            }}
        >
            {children}
        </SocketContext.Provider>
    )
}